import { useAppDrawerContext } from 'components/AppDrawer';
import { useCallback, useEffect } from 'react';

export const useCloseAppDrawerOnNavigation = () => {
  const appDrawerContext = useAppDrawerContext();

  const onPageUnmount = useCallback(() => {
    if (!appDrawerContext || appDrawerContext.appDrawerState?.locked) {
      return;
    }
    appDrawerContext.appDrawerControls.closeDrawer();
  }, [appDrawerContext]);

  useEffect(() => {
    return () => onPageUnmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
